<template>
  <div class="bb-confirm-status-soa">
    <div class="bb-confirm-status-soa-buttons">
      <button class="bb-button bb-button_border bb-button_border_gray"
              @click="closeForm"
      >
        NO
      </button>
      <button class="bb-button"
              @click="saveForm"
      >
        YES
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmStatusSoa',
  methods: {
    closeForm () {
      this.$emit('close')
    },
    saveForm () {
      this.$emit('save')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../sass/variables";
  @import "../../../../../../sass/mixins";
  .bb-confirm-status-soa {
    position: relative;
    width: 521px;
    height: auto;
    transition: 0.3s;

    &-buttons {
      display: grid;
      grid-template-columns: 103px 103px;
      grid-gap: 12px;
      align-items: center;
      justify-content: space-around;
      padding: 18px;
      height: 100%;
      background: $color-alabaster;
      border-radius: 0 0 8px 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/ConfirmStatusSoa.vue